import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/buttons.css';
import './styles/deck.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';

// Force HTTP for localhost
const getRedirectUri = () => {
  const origin = window.location.origin;
  return origin.includes('localhost') 
    ? origin.replace('https://', 'http://') 
    : origin;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH0_DOMAIN}
    clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
    authorizationParams={{
      redirect_uri: getRedirectUri(),
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      scope: "openid profile email read:images write:images read:favorites write:favorites"
    }}
    cacheLocation="localstorage"
    useRefreshTokens={true}
  >
    <App />
  </Auth0Provider>
);

reportWebVitals();
